
$(function () {
	'use strict';

	//slider
	var sliderOpt = {
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 500,
		centerMode: true,
		//centerPadding: '48px',
		slidesToShow: 3,
		slidesToScroll: 1,
		cssEase: 'cubic-bezier(0,1,.75,1.1)',
		lazyLoad: 'progressive',
		pauseOnFocus: false,
		pauseOnHover: false,
		prevArrow: '<div class="carousel--prev"><div class="icon--root icon--prev"><div></div><div></div><div></div></div></div>',
		nextArrow: '<div class="carousel--next"><div class="icon--root icon--next"><div></div><div></div><div></div></div></div>',
		responsive: [
            {
    			breakpoint: 901,
    			settings: {
    				slidesToShow: 1,
    				arrows: false,
    				dots: true,
    				dotsClass: 'sliderDots',
                  centerPadding: '20vw',
    			}
    		},
          {
    			breakpoint: 768,
    			settings: {
                  slidesToShow: 1,
    				arrows: false,
    				dots: true,
    				dotsClass: 'sliderDots',
                  centerPadding: '7.5vw'
    			}
    		}
        ]
	};
	var slider = $('.slider').slick(sliderOpt);

});
